import { useEffect, useState } from "react";
import { ISupplier } from "../../models/Supplier";
import ConfirmModal from "../shared/Confirm/ConfirmModal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { NumberInput } from "../shared/Inputs/NumberInput";
import { TextInput } from "../shared/Inputs/TextInput";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import useSuppliers from "../../data/useSuppliers";
import useSingleSupplier from "../../data/useSingleSupplier";
import { useForm } from "react-hook-form";
import SwitchInput from "../shared/Inputs/SwitchInput";
import { ContactType, IContact } from "../../models/Contact";
import { co } from "@fullcalendar/core/internal-common";

type FormValues = {
    name: string,
    description: string,
    // Contact Information

};

export default function AddEditSupplier({ supplier, setOpen }: { supplier?: ISupplier | undefined, setOpen: any }) {
    const { deleteHandlers, saveHandlers } = useDefaultCRUDHandlers("Supplier");
    const { create } = useSuppliers();
    const { update, remove } = useSingleSupplier(supplier?.id ?? "");
    const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
    const { register, handleSubmit, reset, watch, setValue } = useForm<FormValues>();

    const onSubmit = (data: any) => {
        console.log("Form Data", data);

        const updatedSupplier = {
            ...data,
            ...supplier,
        };

        if (supplier !== undefined) {
            update.mutate(updatedSupplier, {
                onSuccess: (data) => {
                    saveHandlers.onSuccess();
                    setOpen(false);
                    reset({});
                },
                onError: saveHandlers.onError
            });
        } else {
            create.mutate(updatedSupplier, {
                onSuccess: (data) => {
                    saveHandlers.onSuccess();
                    setOpen(false);
                    reset({});
                },
                onError: saveHandlers.onError
            });
        }
    }

    const handleDelete = () => {
        remove.mutate(supplier?.id!, {
            onSuccess: (data) => {
                deleteHandlers.onSuccess();
                setOpen(false);
                reset({});
            },
            onError: deleteHandlers.onError
        });
    }

    useEffect(() => {
        if (supplier !== undefined) {
            reset({ ...supplier, ...supplier.contact });
        } else reset({})
    }, [supplier, reset]);

    return (
        <>
            <ConfirmModal open={deleteOpen} setOpen={setDeleteOpen}
                title="Delete Supplier" message="Are you sure you want to delete this supplier?"
                confirmButtonText="Delete" onConfirm={handleDelete} isLoading={false}
            />

            <h1 className="text-xl">{`${supplier ? "Edit" : "Add"} a Supplier`}</h1>
            <small className="text-gray-500"><i>
                {supplier ? "Edit the supplier details" : "Add a new supplier"}
            </i></small>

            <div className="mt-4">
                <form className="space-y-4 border-t border-gray-200 pt-4" onSubmit={handleSubmit(onSubmit)} >
                    {/* <div className="pt-4 space-x-4 space-y-4 sm:space-y-6"> */}
        
                        <TextInput label="Name" registerName="name" register={register} />
                        <TextInput label="Description" registerName="description" richText={true} register={register} />
            
                        <h2>Contact Details</h2>
                        <hr />
                        {/* ------------------------------------------ */}
                        <div className="grid grid-cols-3 gap-x-4 gap-y-4 sm:grid-cols-1">
                            <TextInput label="Full Name" registerName="fullname" register={register} />
                            <TextInput label="Email" registerName="email" register={register} />
                            <TextInput label="Primary Phone" registerName="telephone1" register={register} />

                            <div className="col-span-3">
                                <TextInput label="Notes" registerName="notes" richText={true} register={register} />
                            </div>

                            
                        </div>
                        {/* ------------------------------------------ */}

                        <h2>Address Details</h2>
                        <hr />
                        <div className="grid grid-cols-2 gap-x-4 gap-y-4 sm:grid-cols-1">
                            <TextInput label="Address Line 1" registerName="addressLine1" register={register} />
                            <TextInput label="Address Line 2" registerName="addressLine2" register={register} />
                        </div>
                        <div className="grid grid-cols-2 gap-x-4 gap-y-4"> 
                            <TextInput label="postcode" registerName="postcode" register={register} />
                            <TextInput label="town" registerName="town" register={register} />
                            <TextInput label="city" registerName="city" register={register} />
                            <TextInput label="county" registerName="county" register={register} />
                        </div>
            
                        <ButtonInput label={`${supplier ? "Save Changes" : "Create"}`} isSubmit={true} onClick={undefined} classes={"float-right"} />
                        {supplier !== undefined && (
                            <ButtonInput 
                                label={"Delete"} 
                                isSubmit={false} 
                                onClick={() => (setDeleteOpen(true))} 
                                classes={"!bg-red-500 hover:!bg-red-600"} 
                            />
                        )}
                    {/* </div> */}
                </form>
            </div>
        </>
    )
}